import { Star, BadgeCheck } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const reviews = [
  { name: "Servesh Gupta", time: "a year ago", text: "Good work by the owner, he installed CCTV in our godown and home as well. Very humble person and rate given was also better from the market.", tag: "HOME + GODOWN" },
  { name: "Harsh Sharma", time: "a year ago", text: "Very reasonable pricing, A1 video quality camera, and really helpful and hardworking workmen. Anaya CCTV gives best service in CCTV work. Highly recommended.", tag: "CCTV INSTALL" },
  { name: "Tasleem Shah", time: "a year ago", text: "I recently had the pleasure of working with Ananya CCTV to install CCTV cameras for my shop! They provide excellent service! 10/10.", tag: "SHOP" },
  { name: "Faizan Rana", time: "a year ago", text: "Excellent service with top-quality products. Their team is professional, reliable, and ensures complete customer satisfaction. Highly recommended for all your security needs!", tag: "FULL SETUP" },
  { name: "Reena Maan", time: "a year ago", text: "Anaya CCTV Security Solutions offers excellent electric locks and video doorbell services with reliable installation and great customer support.", tag: "LOCKS + DOORBELL" },
  { name: "Deepanshu Singh", time: "Google review", text: "Best provider of CCTV service and installation. Highly recommended.", tag: "CCTV SERVICE" },
];

const Stars = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="reviews" className="relative py-28 sm:py-36 bg-alt border-y border-line noise" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTag index="04" label="Verified Google reviews" />
          <div className="flex flex-wrap items-end justify-between gap-8">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-xl">
              70 neighbours. <span className="text-cyan-400">Zero complaints.</span>
            </h2>
            <div className="flex items-center gap-5" data-testid="google-rating-badge">
              <span className="font-display font-extrabold text-6xl sm:text-7xl leading-none">5.0</span>
              <div>
                <Stars />
                <p className="mt-2 font-mono2 text-[11px] tracking-[0.18em] text-soft uppercase flex items-center gap-1.5">
                  <BadgeCheck className="w-3.5 h-3.5 text-cyan-400" /> 70 Google reviews
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.07}>
              <figure
                data-testid={`review-card-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="h-full bg-card border border-line rounded-2xl p-7 flex flex-col transition-colors duration-500 hover:border-amber-400/30"
              >
                <div className="flex items-center justify-between">
                  <Stars />
                  <span className="font-mono2 text-[10px] tracking-[0.15em] text-cyan-300/70 border border-cyan-400/20 rounded-full px-2.5 py-1">{r.tag}</span>
                </div>
                <blockquote className="mt-5 text-sm text-body leading-relaxed flex-1">"{r.text}"</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-line flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-cyan-500/15 border border-cyan-400/30 flex items-center justify-center font-display font-bold text-cyan-300 text-sm">
                    {r.name[0]}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-strong">{r.name}</p>
                    <p className="text-xs text-strong0">{r.time} · Google</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
